<template>
  <div>
    <ListMetrics
      v-if="isLoading || hasKeyword"
      :checked="checked"
      gaType="ua"
      :items="summary.data.items"
      :itemData="itemData"
      :period="period"
      :isLoading="summary.isLoading"
      @change="updateChecked"
    />
    <div class="p-seed-keywords-graph">
      <GraphKeyword
        :checked="checked"
        :data="term.data"
        :itemData="itemData"
        :period="period"
        :project="project"
        :tasks="task.data.items"
        :keywordId="keywordId"
        :isLoading="term.isLoading"
        :selected="selected"
      />
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { CALENDAR } from '@/constants';
import GraphKeyword from '@/components/siteImportantKeyword/GraphKeyword';
import ListMetrics from '@/components/ListMetrics';
import apiProjects from '@/api/projects';
import utils from '@/utils';

export default {
  props: {
    device: {
      type: String,
      required: true
    },
    keywordId: {
      type: String,
      required: false
    },
    period: {
      type: Array,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    selected: {
      type: Object,
      required: false
    }
  },
  components: {
    GraphKeyword,
    ListMetrics
  },
  data() {
    return {
      checked: this.$store.state.page.siteImportantKeyword.checked,
      itemData: {
        position: {
          color: 'purple',
          icon: 'rank_change',
          label: '平均順位',
          type: 'rank',
          unit: '位'
        },
        clicks: {
          color: 'green',
          icon: 'mouse',
          label: 'クリック数',
          type: 'number',
          unit: '回'
        },
        ctr: {
          color: 'pink',
          icon: 'percent',
          label: 'クリック率',
          type: 'percentage',
          unit: '%'
        },
        conversion: {
          color: 'light-blue',
          icon: 'conversion',
          label: 'コンバージョン合計値',
          type: 'number',
          children: {
            directConversion: {
              color: 'light-blue',
              label: '直接CV',
              type: 'number'
            },
            assistedConversion: {
              color: 'light-light-blue',
              label: '間接CV',
              type: 'number'
            }
          }
        }
      },
      summary: {
        data: {
          items: {}
        },
        isLoading: true
      },
      task: {
        data: {
          items: []
        }
      },
      term: {
        data: {
          items: []
        },
        isLoading: true
      }
    };
  },
  computed: {
    hasKeyword() {
      return this.keywordId ? true : false;
    }
  },
  watch: {
    device: {
      handler(value) {
        this.getData();
      }
    },
    keywordId: {
      handler(value) {
        if (value) {
          this.getData();
          this.getTasks();
        }
      },
      immediate: true
    },
    period: {
      handler(value) {
        this.getData();
      }
    },
    isLoading: {
      handler(value) {
        // キーワードが1個もない時はローディング表示をやめる
        if (!value && !this.hasKeyword) {
          this.summary.isLoading = false;
          this.term.isLoading = false;
        }
      }
    }
  },
  methods: {
    getData() {
      this.getSummary();
      this.getTerm();
    },
    getSummary() {
      if (!this.hasKeyword) {
        return;
      }
      this.summary.isLoading = true;

      const params = {
        country: 'JPN',
        device: this.device,
        from: utils.formatDate(this.period[0]),
        to: utils.formatDate(this.period[1])
      };

      return apiProjects.observationKeywords.detail.metricsSummary
        .get(params, this.auth.idToken, this.project.id, this.keywordId)
        .then(response => {
          this.summary.data.items = response.data;
          this.summary.isLoading = false;
        })
        .catch(error => {
          this.summary.isLoading = false;
        });
    },
    getTasks() {
      let params = {
        columns: 'done',
        observationKeywordId: this.keywordId,
        order: 'createdDate:desc'
      };
      return apiProjects.tasks
        .get(params, this.auth.idToken, this.project.id)
        .then(response => {
          this.task.data.items = response.data.items;
        });
    },

    getTerm() {
      if (!this.hasKeyword) {
        return;
      }
      this.term.isLoading = true;

      const params = {
        country: 'JPN',
        device: this.device,
        from: utils.formatDate(this.period[0]),
        to: utils.formatDate(this.period[1]),
        type: 'term'
      };

      return apiProjects.observationKeywords.detail.metricsTerm
        .get(params, this.auth.idToken, this.project.id, this.keywordId)
        .then(response => {
          let items = [];
          const total = response.data.items.length;
          for (let i = 0; i < total; i++) {
            const item = response.data.items[i];
            const date = utils.getDateResetHours(item.date);
            // 指定期間範囲内のデータのみitemsに入れる
            // FakeAPIの場合、期間を1日のみ選択した時でも全データを返してきて、グラフの表示がおかしくなるため
            // FakeじゃないAPIの場合でも、直近3日間のデータはカットする
            if (
              date >= this.period[0] &&
              date <= this.period[1] &&
              date <= CALENDAR.gsc.maxDate
            ) {
              item.date = date;
              item.conversion = item.assistedConversion + item.directConversion;
              if (item.ctr) {
                item.ctr *= 100;
              }
              items.push(item);
            }
          }
          this.term.data.items = items;
          this.term.isLoading = false;
        })
        .catch(error => {
          this.term.isLoading = false;
        });
    },
    updateChecked(checked) {
      this.checked = checked;

      this.$store.dispatch('page/setStatus', {
        page: 'siteImportantKeyword',
        status: {
          checked: checked
        }
      });
    }
  }
};
</script>
